(function () {
  // 12 October 2026, 09:00:00 Asia/Kolkata = 03:30:00 UTC
  var TARGET = Date.UTC(2026, 9, 12, 3, 30, 0);
  function pad(n) {
    n = Math.max(0, Math.floor(Number(n) || 0));
    return String(n).padStart(2, "0");
  }
  function write() {
    var d = document.getElementById("sz-cd-d");
    var h = document.getElementById("sz-cd-h");
    var m = document.getElementById("sz-cd-m");
    var s = document.getElementById("sz-cd-s");
    var line = document.getElementById("sz-cd-line");
    var closed = document.getElementById("sz-cd-closed");
    if (!d || !h || !m || !s) return;
    var remaining = TARGET - Date.now();
    if (!isFinite(remaining)) return;
    if (remaining < 0) remaining = 0;
    if (remaining <= 0 && Date.now() < TARGET - 1000) return;
    var dd = Math.floor(remaining / 86400000);
    var hh = Math.floor((remaining % 86400000) / 3600000);
    var mm = Math.floor((remaining % 3600000) / 60000);
    var ss = Math.floor((remaining % 60000) / 1000);
    d.textContent = String(dd).padStart(2, "0");
    h.textContent = pad(hh);
    m.textContent = pad(mm);
    s.textContent = pad(ss);
    if (line) {
      line.textContent = dd + " days " + pad(hh) + " hours " + pad(mm) + " minutes " + pad(ss) + " seconds";
    }
    if (closed) closed.hidden = remaining > 0;
  }
  write();
  setInterval(write, 250);

  document.querySelectorAll(".grphx-sz-form").forEach(function (form) {
    form.addEventListener("submit", function () {
      var phone = form.querySelector('[name="contact[phone]"]');
      var digits = phone ? String(phone.value || "").replace(/\D/g, "") : "";
      if (phone) phone.value = digits;
      var hook = (window.GRPHX_SZ_WEBHOOK || "").trim();
      if (!hook) return;
      try {
        fetch(hook, {
          method: "POST",
          mode: "no-cors",
          headers: { "Content-Type": "text/plain" },
          body: JSON.stringify({
            type: "subzero-waitlist",
            name: (form.querySelector('[name="contact[name]"]') || {}).value || "",
            email: (form.querySelector('[name="contact[email]"]') || {}).value || "",
            phone: digits,
            at: new Date().toISOString()
          })
        });
      } catch (err) {}
    });
  });
})();
